export default function initTabs() {
  commonTab();
}

/**
 * ヘッダーの高さをCSS変数に設定する関数
 * 要素のリサイズを検知して再取得します。
 */
function commonTab() {
  const tabs = document.querySelectorAll(".js-tabs");
  if (!tabs) return;
  tabs.forEach((tabBlock) => {
    const navItems = tabBlock.querySelectorAll(".js-tabs__nav-item");
    const contents = tabBlock.querySelectorAll(".js-tabs__content");
    if (!navItems.length || !contents.length) return;

    // 初期表示
    navItems.forEach((nav, i) => nav.classList.toggle("is-active", i === 0));
    contents.forEach(
      (content, i) => (content.style.display = i === 0 ? "block" : "none")
    );

    // タイトルクリックで切替
    navItems.forEach((navItem, index) => {
      navItem.addEventListener("click", () => {
        navItems.forEach((n) => n.classList.remove("is-active"));
        navItem.classList.add("is-active");

        contents.forEach((content, i) => {
          content.style.display = i === index ? "block" : "none";
        });
      });
    });
  });
}
